import React from "react";
import styles from "./styles.module.scss";
import DownloadDocumentButton from "./../../common/DownloadDocumentButton/index";

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];

const isImageFile = (fileName, mimeType) => {
    // Проверяем по MIME типу
    if (mimeType && mimeType.startsWith('image/')) {
        return true;
    }
    // Проверяем по расширению файла
    if (!fileName) return false;
    const extension = fileName.split('.').pop()?.toLowerCase();
    return IMAGE_EXTENSIONS.includes(extension);
};

const ImagePreview = ({ url, fileName }) => {
    const [imageError, setImageError] = React.useState(false);

    const handleClick = (e) => {
        e.preventDefault();
        if (url) {
            window.open(url, '_blank');
        }
    };

    const handleError = () => {
        setImageError(true);
    };

    // Если URL отсутствует или изображение не загрузилось - показываем имя файла
    if (!url || imageError) {
        return (
            <div className={styles.message__imageWrapper}>
                <span className={styles.message__imagePlaceholder}>{fileName}</span>
            </div>
        );
    }

    return (
        <div className={styles.message__imageWrapper}>
            <img
                src={url}
                alt={fileName}
                className={styles.message__image}
                onClick={handleClick}
                onError={handleError}
            />
        </div>
    );
};

const FileMessage = ({ files }) => {
    return (
        <div className={styles.message__documents}>
            {files.map((document, index) => {
                const fileName = document.file_name || document.originalname || document.name;
                const url = document.document_url || document.url;
                const mimeType = document.mimetype || document.type;

                if (isImageFile(fileName, mimeType)) {
                    return <ImagePreview key={index} url={url} fileName={fileName} />;
                }

                return (
                    <DownloadDocumentButton
                        url={url}
                        key={index}
                        fileName={fileName}
                        className={styles.message__document}
                        text={
                            <>
                                <span>{fileName}</span>
                                <span className={styles.message__download} />
                            </>
                        }
                    />
                );
            })}
        </div>
    );
};

export default FileMessage;
